import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=4207300d&scoped=true"
import script from "./CheckboxItem.vue?vue&type=script&lang=ts"
export * from "./CheckboxItem.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxItem.vue?vue&type=style&index=0&id=4207300d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207300d",
  null
  
)

export default component.exports